import { render, staticRenderFns } from "./InjurySummary.vue?vue&type=template&id=6120df92&scoped=true"
import script from "./InjurySummary.vue?vue&type=script&lang=js"
export * from "./InjurySummary.vue?vue&type=script&lang=js"
import style0 from "./InjurySummary.vue?vue&type=style&index=0&id=6120df92&prod&scoped=true&lang=scss"
import style1 from "./InjurySummary.vue?vue&type=style&index=1&id=6120df92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120df92",
  null
  
)

export default component.exports